// extracted by mini-css-extract-plugin
module.exports = {"menuSection":"Collection_menuSection__2JrQ-","collectionCardWrapper":"Collection_collectionCardWrapper__nHF7t","link":"Collection_link__1dJa-","header":"Collection_header__2310W"};